module.exports = __webpack_public_path__ + "img/xenia.fb4e954c.jpeg";